import type {
    ContentOutput,
    ForOutput,
    ImportCachedInstanceSymbol,
    ImportCachedOutput,
    ImportCachedSymbol,
    PluginOutput,
} from "@magic-md/core";

type ImportCachedAnySymbol = ImportCachedSymbol | ImportCachedInstanceSymbol;
type ImportCachedAnyOutput = PluginOutput | ContentOutput | ForOutput;

function getSourceSymbolId(sym: ImportCachedAnySymbol): string | undefined {
    return "sourceId" in sym ? sym.sourceId : sym.originalId ?? sym.publicName;
}

export function getImportCachedSymbolOutput(
    namespace: string,
    output: ImportCachedOutput,
    sym: ImportCachedAnySymbol,
): ImportCachedAnyOutput | undefined {
    const sourceId = getSourceSymbolId(sym);
    const privateId = sourceId ? `${namespace}/__import__/${sourceId}` : undefined;

    const instanceOutput = "sourceId" in sym
        ? output.instanceOutputs?.[sym.qualifiedId]
        : (privateId ? output.instanceOutputs?.[privateId] : undefined)
            ?? output.instanceOutputs?.[sym.qualifiedId];
    if (instanceOutput !== undefined) return instanceOutput;

    if (!sourceId || !output.document) return undefined;

    if (sym.kind === "content") {
        return output.document.contentOutputs?.[sourceId]
            ?? output.document.contentDefinitions?.[sourceId]?.output;
    }

    if (sym.kind === "for") {
        return output.document.forOutputs?.[sourceId]
            ?? output.document.forDefinitions?.[sourceId]?.output;
    }

    return output.document.outputs?.[sourceId]
        ?? output.document.definitions?.[sourceId]?.output;
}
